import { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import Modal, { ModalRef } from "../Modal";
import View from "../Base/View";
import { toast } from "../../utils/toast";
import util from "../../utils/util";
import Text from "../Base/Text";
import rm from "../../utils/rm";
import './index.scss'

export interface ShipmentListModalRef {
    open: (productInfo: any) => void
}

const ShipmentListModal = forwardRef((prop, ref) => {

    const [productInfo, setProductInfo] = useState<any>();
    const modalRef = useRef<ModalRef>();

    const _jumpTacking = useCallback((_productInfo: any, index: number) => {
        util.navigateTo(_productInfo.ShipmentModels[index].TrackUrl)
    }, [])

    useImperativeHandle(ref, () => ({
        open: (productInfo: any) => {
            if (productInfo.ShipmentModels.length == 0) {
                toast.info('暂无物流信息')
                return
            }
            if (productInfo.ShipmentModels.length > 0) {
                setProductInfo(productInfo);
                modalRef.current?.open();
            } else {
                _jumpTacking(productInfo, 0)
            }
        }
    }))

    return productInfo ? <Modal
        className="shipmentListModal"
        ref={modalRef}
    >
        <View className="modal-title">物流信息</View>
        {productInfo.ShipmentModels.map((item: any, index: number) => {
            return (
                <View key={item.Title} className="modal-section">
                    <View className="shipment-method-info">
                        <View className="shipment-method-name">
                            {item.ExpressCompany}
                        </View>
                        <View className="shipment-method-id">
                            <Text>{'运单号：' + item.TrackingNumber}</Text>
                            <View
                                className="copy-number"
                                data-index={index}
                                onClick={() => {
                                    rm.setClipboardData(`${productInfo.ShipmentModels[index].TrackingNumber}`, () => {
                                        toast.info("已复制")
                                    })
                                }}
                            >
                                复制单号
                            </View>
                        </View>
                    </View>
                    <View
                        className="shipment-status-view"
                        data-index={index}
                        onClick={() => {
                            _jumpTacking(productInfo, index);
                        }}
                    >
                        查看物流
                    </View>
                </View>
            )
        })}
        <View className="modal-confirm-btn" onClick={() => {
            modalRef.current?.close();
        }}>
            关闭
        </View>
    </Modal> : null
})

export default ShipmentListModal;